import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
//#region components
import { useMountedState } from "components/common";
//#endregion

function useOCRCollisions(invoice: WintSuperkollAPIModel.IncomingInvoice) {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { getMounted } = useMountedState();

  const [ocrCollisions, setCollisions] = React.useState<number[]>([]);

  const getOcrCollisions = () => {
    return invoice.oCRCollisions !== undefined
      ? new Promise<number[]>((resolve) => resolve(invoice.oCRCollisions ?? []))
      : incomingInvoiceService.getOcrCollisions(invoice.id);
  };

  React.useEffect(() => {
    getOcrCollisions().then((ocrCollisions) => {
      if (getMounted()) {
        setCollisions(ocrCollisions);
      }
    });
  }, [invoice.id, invoice.oCRCollisions]);

  return ocrCollisions;
}

export default useOCRCollisions;
